function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M74.2809 129.092L71.2697 91.4709L29.8652 72.6602L53.9551 120.063L29.8652 122.32L43.4157 135.112L-1 154.675L53.9551 172.733H66.7528C62.236 164.456 62.9888 142.636 74.2809 129.092Z",
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("path", {
  d: "M115.685 122.32H90.0899L76.5393 23H125.472L115.685 122.32Z",
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("path", {
  d: "M129.236 129.092L135.258 72.6602L166.124 52.3447L145.798 112.539H200L163.865 154.675L184.944 172.733H139.775C141.281 159.189 144.292 141.131 129.236 129.092Z",
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("path", {
  d: "M126.225 157.684C126.978 140.379 120.202 136.617 102.888 136.617C83.3146 136.617 78.0449 140.379 78.0449 157.684C78.0449 174.99 85.573 178 103.64 178C121.708 178 125.472 174.99 126.225 157.684Z",
  fill: "currentColor"
}));

var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0"
}, /*#__PURE__*/React.createElement("rect", {
  width: 200,
  height: 200,
  fill: "white"
})));

function SvgCrisis(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 200,
    height: 200,
    viewBox: "0 0 200 200",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrisis);
export default __webpack_public_path__ + "static/media/crisis.3d571398.svg";
export { ForwardRef as ReactComponent };